import axios from 'axios'
import {hideLoading,showNotify,useDefaultAuthStatus} from '@/utils'

const defaultAuthStatus = useDefaultAuthStatus();

let baseURL = process.env.VUE_APP_BASE_URL;
const service = axios.create({
    baseURL: baseURL,
    // baseURL: "https://miniapi.jieyou.pro/ttconfig",
    timeout: 60000
});

service.interceptors.request.use((config) => {
    return config;
}, (error) => {
    showNotify('danger','请求出错');
    hideLoading();
    return Promise.reject(error);
});

service.interceptors.response.use((resp) => {
    !isHideLoading(resp) && hideLoading();
    const {code,msg,data} = resp.data
    if(code == 401){
        defaultAuthStatus.value = true;
        return Promise.reject(msg)
    }
    else if(code != 200){
        showNotify('danger',msg);
        return Promise.reject(msg)
    }
    return resp.data
}, (error) => {
    showNotify('danger','请求失败');
    hideLoading();
    return Promise.reject(error);
});


function isHideLoading(config){
    let custom = config.customConfig;
    if(custom){
        return custom.hideLoading === true;
    }
    return false;
}

export default {
    post(url,requestForm,config){
        return service.post(url,requestForm,{customConfig:config})
    },
    get(url,requestForm,config){
        return service.get(url,{params: requestForm,customConfig: config});
    },

}